import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const BetItemWrapperBetCancel = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  position: relative;
  margin-top: 0;
`;

export const BetCancelContainer = styled.div`
  padding: 12px;
  flex-direction: column;
  display: flex;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px 12px;

  button:not(:last-child) {
    margin-bottom: 8px;
  }

  background-color: ${buildColor("white", "100")};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const SeeRulesContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const BetCancelLoadingMask = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  background-color: ${buildColor("white", "100")};
`;
